import { createContext, useState, useContext, useEffect, useMemo } from "react";
import PropTypes from "prop-types";

const AvatarContext = createContext();

export const AvatarProvider = ({ children }) => {
  const [avatarData, setAvatarData] = useState(null);

  useEffect(() => {
    const storedAvatar = localStorage.getItem("childAvatar");
    if (storedAvatar) {
      setAvatarData(JSON.parse(storedAvatar));
    }
  }, []);

  const value = useMemo(
    () => ({
      avatarData,
      setAvatarData,
    }),
    [avatarData]
  );

  return (
    <AvatarContext.Provider value={value}>{children}</AvatarContext.Provider>
  );
};
export const useAvatar = () => useContext(AvatarContext);

AvatarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
